<template>
  <el-form-item
    :label="label"
    class="import-file is-required"
    :prop="prop"
    :rules="rules"
  >
    <el-upload
      ref="upload"
      class="upload"
      :action="formAction"
      :headers="headers"
      :data="options"
      :limit="1"
      :auto-upload="false"
      :on-success="importSuccess"
      :on-error="importError"
      :http-request="httpRequest"
      :disabled="disabled"
      :autofocus="autofocus"
    >
      <el-button slot="trigger" @click="clear">選択</el-button>
    </el-upload>
  </el-form-item>
</template>

<script>
import Encoding from 'encoding-japanese'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    label: String,
    prop: {
      type: String,
      default: 'importFile'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    action: String,
    extension: String,
    params: Object
  },
  data () {
    return {
      headers: this.$axios.defaults.headers.common
    }
  },
  computed: {
    options: {
      get () {
        return {
          ...this.params
        }
      }
    },
    formAction: {
      get () {
        return this.$axios.defaults.baseURL + this.action
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          this.$nextTick(() => {
            rules.push(this.validatorFileSelected(this.$refs.upload, this.extension))
            if (this.extension) {
              rules.push(this.validatorFileExtension(this.$refs.upload, this.extension))
            }
            rules.push(this.validatorFileEmpty(this.$refs.upload))
            rules.push(this.validatorFileMaxSize(this.$refs.upload))
          })
        }
        return rules
      }
    }
  },
  methods: {
    import () {
      this.$refs.upload.submit()
    },
    importSuccess (res) {
      this.$emit('import-success', res)
    },
    importError (res) {
      this.$emit('import-error', res)
    },
    httpRequest (request) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const array = new Uint8Array(e.target.result)
        const detected = Encoding.detect(array)
        const utf8Array = Encoding.convert(array, {
          to: 'UNICODE',
          from: detected
        })
        const params = { ...request.data }
        params.import_data = Encoding.codeToString(utf8Array)
        this.$axios
          .post(request.action, params)
          .then(res => {
            request.onSuccess(res)
          })
          .catch(e => {
            request.onError(e.response)
          })
      }
      reader.readAsArrayBuffer(request.file)
    },
    clear () {
      this.$refs.upload.clearFiles()
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  display: flex;
  ::v-deep .el-upload {
    order: 2;
  }
  ::v-deep .el-upload-list {
    order: 1;
    width: calc(100% - 1em - 72px);
    margin-right: 1em;
    background-color: #F5F7FA;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    .el-upload-list__item {
      margin-top: 7px;
    }
  }
}
</style>
